/**
 * 生成固定的随机图片 URL（与 CourseSelection 保持一致）
 */
export function getNotebookImage(notebookTitle) {
  return `https://picsum.photos/seed/${encodeURIComponent(notebookTitle)}/400/200`;
}
